<template>
<div class="ecology-service">
  <div class="content">
    <h2>创新服务</h2>
    <div class="content-box">
      <div class="item1">
        <div class="title">鸿蒙通用性测评</div>
        <div class="equipment">
          <div>
            <img src="@/assets/img/2.0/ecology/equipment1.png" alt="">
            <div class="title">轻量设备</div>
            <p>面向MCU类处理器，
              例如Arm Cortex-M、RISV-V 32位的设备，支持的设备最小内存为128KiB</p>
          </div>
          <div>
            <img src="@/assets/img/2.0/ecology/equipment2.png" alt="">
            <div class="title">小型设备</div>
            <p>面向应用处理器，例如Arm Cortex-A、的设备，参考内存≥1MB</p>
          </div>
          <div>
            <img src="@/assets/img/2.0/ecology/equipment3.png" alt="">
            <div class="title">标准设备</div>
            <p>面向应用处理器，例如Arm Cortex-A、的设备，参考内存≥1MB</p>
          </div>
        </div>
        <div class="img-box">
          <div>openharmony XTS认证</div>
          <div>鸿蒙智联产品认证</div>
        </div>
      </div>
      <div class="item2">
        <div class="title">软件测评</div>
        <div class="gitee-box">
          <div class="left">
            <img src="@/assets/img/2.0/ecology/gitee.png" alt="">
            <div class="left-title">自动化测试</div>
            <p>提供 App 自动化测试、Web 自动化测试和云真机等工具。</p>
            <div class="items">
              <div>Web 自动化测试</div>
              <div>APP 自动化测试</div>
              <div>云真机</div>
            </div>
          </div>
          <div class="right">
            <div @click="evaluation">
              <img src="@/assets/img/2.0/ecology/test1.png" alt="">
              <div>
                <div>功能测试</div>
                <p>关注功能正常（包含兼容性测试）</p>
              </div>
            </div>
            <div @click="evaluation">
              <img src="@/assets/img/2.0/ecology/test2.png" alt="">
              <div>
                <div>性能测试</div>
                <p>关注（比如前端性能、后端性能）</p>
              </div>
            </div>
            <div @click="evaluation">
              <img src="@/assets/img/2.0/ecology/test3.png" alt="">
              <div>
                <div>安全测试</div>
                <p>关注传输、存储等安全</p>
              </div>
            </div>
            <div @click="evaluation">
              <img src="@/assets/img/2.0/ecology/test4.png" alt="">
              <div>
                <div>特性测试</div>
                <p>特性指平台差异（即部分兼容性测试）</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item3">
        <div class="title">硬件测评</div>
        <div class="list-box">
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/1.png" alt="">
            <div class="info-right">
              <div>
                <div>Keysight Robot</div>
                <p class="text-overflow2">防静电等级测试，主要面向展厅公共区域信息发布等场景，提供统一的屏幕管理和播放控制能。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                常州扬子
              </div>
            </div>
          </div>
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/2.png" alt="">
            <div class="info-right">
              <div>
                <div>EFT 群脉冲测试仪</div>
                <p class="text-overflow2">群脉冲测试，马达物流供应链云是一款数字化的仓储物流运输协同平台，功能涵盖功能数据强一致、集群高可用等特性。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                普锐马
              </div>
            </div>
          </div>
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/3.png" alt="">
            <div class="info-right">
              <div>
                <div>PSA6000-Pro专业版</div>
                <p class="text-overflow2">电源电压跌落测试，主要面向展厅公共区域信息发布等场景，提供统一的屏幕管理和播放控制能。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                极致汇仪
              </div>
            </div>
          </div>
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/4.png" alt="">
            <div class="info-right">
              <div>
                <div>以太网测试仪</div>
                <p class="text-overflow2">以太网通信数据吞吐量测试，主要面向展厅公共区域信息发布等场景，提供统一的屏幕管理和播放控制能。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                虹润
              </div>
            </div>
          </div>
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/5.png" alt="">
            <div class="info-right">
              <div>
                <div>电压电流信号源</div>
                <p class="text-overflow2">高精度电压和电流信号发生器，主要面向展厅公共区域信息发布等场景，提供统一的屏幕管理和播放控制能。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                优利德
              </div>
            </div>
          </div>
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/6.png" alt="">
            <div class="info-right">
              <div>
                <div>浪涌测试仪</div>
                <p class="text-overflow2">浪涌测试，主要面向展厅公共区域信息发布等场景，提供统一的屏幕管理和播放控制能。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                海达
              </div>
            </div>
          </div>
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/7.png" alt="">
            <div class="info-right">
              <div>
                <div>多路温度测试仪</div>
                <p class="text-overflow2">温升测试，主要面向展厅公共区域信息发布等场景，提供统一的屏幕管理和播放控制能。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                信而泰
              </div>
            </div>
          </div>
          <div @click="evaluation">
            <img class="img" src="@/assets/img/2.0/ecologyitem/8.png" alt="">
            <div class="info-right">
              <div>
                <div>电子负载仪</div>
                <p class="text-overflow2">电源负载测试，主要面向展厅公共区域信息发布等场景，提供统一的屏幕管理和播放控制能。</p>
              </div>
              <div>
                <img src="@/assets/img/2.0/mall/company.png" alt="" />
                厦门智能
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import VImg from '@/components/VImg.vue'

export default {
  components: {VImg},
  computed: {
    ...mapGetters(["isLogin"]),
  },
  methods:{
    evaluation() {
      if (!this.isLogin) {
        this.$router.push('/login')
      }else{
        window.open(`${process.env.VUE_APP_ACCOUNT_PREFIX}/consult/evaluation`);
      }
    }
  }
}
</script>


<style scoped lang="scss">
.ecology-service{
  background: #F8FAFC;
  .content{
    width: 1280px;
    margin: 0 auto;
    padding: 64px 0;
    >h2{
      font-weight: 600;
      font-size: 32px;
      color: rgba(0,0,0,0.85);
      line-height: 44px;
      text-align: center;
      margin-bottom: 36px;
    }
  }

  .content-box{
    background: #FFFFFF;
    padding: 0 32px;
    .title{
      font-weight: 500;
      font-size: 24px;
      color: #000000;
      line-height: 32px;
      margin-bottom: 32px;
    }
    >div{
      padding: 40px 0 32px;
      border-bottom: 1px solid #E8E8E8;
    }
    .equipment{
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;
      >div{
        width: 388px;
        height: 196px;
        padding: 24px;
        background: #F8FAFC;
        >img{

        }
        >.title{
          font-weight: 500;
          font-size: 18px;
          color: rgba(0,0,0,0.85);
          line-height: 24px;
          margin: 24px 0 12px;
        }
        >P{
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
        }
      }

    }
    .img-box{
      display: flex;
      justify-content: space-between;
      >div{
        width: 595px;
        height: 168px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 25px;
      }
      >:first-child{
       background: url("../../../assets/img/2.0/ecology/bg1.png") no-repeat;
       background-size: cover;
      }
      >:nth-child(2){
        background: url("../../../assets/img/2.0/ecology/bg2.png") no-repeat;
        background-size: cover;
      }
    }
    .item2{
      .gitee-box{
        display: flex;
        justify-content: space-between;
        padding: 24px 32px;
        background: url("../../../assets/img/2.0/ecology/bg3.png") no-repeat;
        background-size: cover;
        >.left{
          padding: 8px 0;
          .left-title{
            margin: 16px 0 12px;
            font-weight: 500;
            font-size: 20px;
            color: #262626;
            line-height: 24px;
          }
          >p{
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 24px;
          }
          .items{
            font-weight: 400;
            font-size: 14px;
            color: rgba(0,0,0,0.85);
            line-height: 20px;
            margin-top: 32px;
            >div{
              padding-left: 12px;
              position: relative;
              margin-bottom: 16px;
              &::before{
                position: absolute;
                content: '';
                width: 4px;
                height: 4px;
                background: #EA0B06;
                border-radius: 2px;
                left: 0;
                top: 8px;
              }
            }

          }
        }
        >.right{
          width: 724px;
          display: flex;
          flex-wrap: wrap;
          >div{
            width: 350px;
            height: 132px;
            background: #FFFFFF;
            border: 1px solid #E6E6E6;
            padding: 0 24px;
            display: flex;
            align-items: center;
            cursor: pointer;
            >img{
              margin-right: 24px;
            }
            >div{
              >div{
                font-weight: 400;
                font-size: 18px;
                color: rgba(0,0,0,0.85);
                line-height: 24px;
                margin-bottom: 12px;
              }
              >P{
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                line-height: 20px;
              }
            }
          }
          >:not(:nth-child(2n)){
            margin-right: 24px;
          }
          >:nth-child(-n+2){
            margin-bottom: 24px;
          }
        }
      }
    }
    .item3{
      border-bottom: none;
    }
    .list-box{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      >div{
        cursor: pointer;
        width: 596px;
        height: 183px;
        background: #F8FAFC;
        display: flex;
        padding: 32px 32px 24px;
        .img{
          display: block;
          width: 96px;
          height: 96px;
          margin-right: 24px;
        }
        .info-right{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          >:first-child{
           >div{
             font-weight: 600;
             font-size: 18px;
             color: rgba(0,0,0,0.85);
             line-height: 24px;
             margin-bottom: 10px;
           }
            >p{
              font-weight: 400;
              font-size: 14px;
              color: #666666;
              line-height: 20px;
            }
          }
          >:nth-child(2){
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 12px;
            color: #8C8C8C;
            line-height: 16px;
            >img{
              display: block;
              width: 12px;
              height: 12px;
              margin-right: 8px;
            }
          }
        }
      }
      >:not(:nth-child(-n+2)){
        margin-top: 24px;
      }
    }
  }
}
</style>
